import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';

import { theme } from 'src/theme';
import { AppContextProvider } from 'src/Context';
import FormSteps from 'src/components/FormSteps';

export const App = () => {
  const [isBuiltIn, setIsBuiltIn] = useState<boolean>(false);

  useEffect(() => {
    ReactGA.initialize('UA-232405063-109');

    const params = new URL(window.location.href).searchParams;
    const builtin = params.get('builtin');
    setIsBuiltIn(!!builtin);
  }, []);

  return (
    <ThemeProvider theme={theme(isBuiltIn)}>
      <CssBaseline />
      <AppContextProvider>
        <FormSteps />
      </AppContextProvider>
    </ThemeProvider>
  );
};
